import axios from "axios";

export interface ReportRow {
  admissionNumber: string;
  scholarNumber: string | null;
  studentName: string;
  fatherName: string;
  class: string;
  section: string;
  mobile: string;
  status: string;
  category?: string;
  house?: string;
  religion?: string;
  studentType?: string;
  admissionDate?: string | null;
  gender?: string;
}

export const reportApi = {
  fetch: async (params: Record<string, string | number | boolean | undefined>) => {
    const res = await axios.get<{ items: ReportRow[]; total: number }>("/scholar-register/reports/students", { params });
    return res.data;
  },
  exportExcel: async (params: Record<string, string | number | boolean | undefined>) => {
    const res = await axios.get("/scholar-register/reports/export-excel", {
      params,
      responseType: "blob",
    });
    return res.data as Blob;
  },
};
